import ApplicationAdvancedView from './ApplicationAdvancedView'

export default ApplicationAdvancedView
